/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orderApprovalDetails = {
  back: 'Volver a la lista',
  showForm_APPROVE: 'Aprobar pedido...',
  showForm_REJECT: 'Rechazar pedido...',
  form: {
    title_APPROVE: 'Aprobar pedido {{orderCode}} por un total de {{orderTotal}}',
    title_REJECT: 'Rechazar pedido {{orderCode}} por un total de {{orderTotal}}',
    submit_APPROVE: 'Aprobar',
    submit_REJECT: 'Rechazar',
    cancel: 'Cancelar',
    comment_APPROVE: {
      label: 'Comentario (opcional, máximo 255 caracteres)',
      placeholder: '',
    },
    comment_REJECT: {
      label: 'Comentario (máximo 255 caracteres)',
      placeholder: '',
    },
  },
  permissionResults: {
    header: 'Detalles de aprobación del cliente',
    permission: 'Permiso',
    approver: 'Aprobarr',
    status: 'Estado',
    approverComments: 'Comentarios del Aprobaror',
    noApprovalComments: 'Ninguno',
    permissionType_B2BBudgetExceededPermiso:
      'Se ha superado el presupuesto asociado al centro de coste elegido',
    permissionType_B2BOrderThresholdPermiso:
      'El total del pedido superó el límite por pedido',
    permissionType_B2BOrderThresholdTimespanPermiso:
      'El total de pedidos superó el límite por intervalo de tiempo',
  },
};

export const orderApprovalList = {
  orderCode: 'Orden #',
  POCode: 'DESPUÉS #',
  placedBy: 'Colocado por',
  date: 'Fecha',
  status: 'Estado',
  total: 'Total',
  none: 'Ninguno',
  emptyList: 'No hay órdenes que aprobar en este momento.',
  orderApprovalList: 'Lista de aprobación de pedidos',
};

export const orderApprovalGlobal = {
  notification: {
    noSufficientPermisos: 'No hay permisos suficientes para acceder a esta página.',
  },
};

export const orderApproval = {
  orderApprovalDetails,
  orderApprovalList,
  orderApprovalGlobal,
};
